import React, { useEffect } from 'react';
import { Form, Input, BackTop } from 'antd';
import { useTranslation } from 'react-i18next';
import IconEmailTemplate from '../../../../assets/Images/icons/icon-email-template';
import IconEmailTemplateRight from '../../../../assets/Images/icons/icon-email-template-right';
import IconEmailTemplatActive from '../../../../assets/Images/icons/icon-email-template-active';
import IconFlowInProgress from '../../../../assets/Images/icons/icon-flow-inprogress';
import moment from 'moment';
import parse from 'html-react-parser';

export default function TemplateEmailExtend({
    form,
    contact,
    dsFormData,
    detail,
    logoCompany,
}) {
    const { t, i18n } = useTranslation();
    let lang = i18n.language;
    const { TextArea } = Input;

    useEffect(() => {
        form.setFieldsValue({
            operatorRemark:
                'ขณะนี้เจ้าหน้าที่กำลังเร่งดำเนินการตามคำขอใช้สิทธิของคุณ',
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {/* {template1} */}
            {/* {template1} */}
            {/* {template1} */}
            {/* {template1} */}
            {/* {template1} */}
            {/* {template1} */}
            {/* {template1} */}
            <div className="col-span-1 bg-white h-max rounded-t-lg">
                <div
                    className="px-8 py-4 text-[#7B67FB] text-[16px] font-semibold"
                    style={{ borderBottom: '1px solid #ECECEC' }}
                >
                    อีเมลส่งถึงเจ้าของข้อมูล
                </div>
                <div className="grid grid-cols-12 gap-2">
                    <div className="col-span-12 px-8">
                        <div className="text-[14px] text-[#65707A] my-2">
                            to :{' '}
                            <span className="text-[#1890FF]">
                                {dsFormData?.dataSubjectInformation?.email ||
                                    '-'}
                            </span>
                        </div>
                        <div className="flex justify-between">
                            <div className="text-[14px] text-[#65707A]">
                                cc :{' '}
                                <span className="text-[#1890FF]">
                                    {dsFormData?.applicantInformation?.email ||
                                        '-'}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="px-44 py-14 text-[16px] bg-[#ECECEC] rounded-b-lg mb-4">
                <div className="text-center my-4" hidden={!logoCompany}>
                    <img
                        src={logoCompany}
                        className="object-cover w-auto h-20"
                        alt="logo"
                    />
                </div>
                <div className="p-8 text-[16px] bg-white rounded-lg">
                    <div className="text-[14px] font-semibold">
                        {' '}
                        คำขอใช้สิทธิของคุณ หมายเลข
                        <span className="text-[#1890FF]">
                            {' '}
                            {detail?.requestId || '-'}{' '}
                        </span>
                        ที่มีการเปิดคำขอใช้สิทธิเมื่อวันที่
                        <span className="text-[#1890FF]">
                            {' '}
                            {detail?.requestDate
                                ? moment(detail?.requestDate).format(
                                      'DD/MM/YYYY'
                                  )
                                : '-'}{' '}
                        </span>
                    </div>
                    <p className="text-[14px] font-semibold">
                        และคาดว่าจะดำเนินการให้แล้วเสร็จภายในวันที่
                        <span className="text-[#1890FF]">
                            {' '}
                            {detail?.dueDate
                                ? moment(detail?.dueDate).format('DD/MM/YYYY')
                                : '-'}{' '}
                        </span>
                    </p>
                    <div className="text-[14px] font-semibold">
                        เนื่องด้วยกระบวนการดำเนินตามคำขอใช้สิทธินี้อาจมีความล้าช้ากว่ากำหนด
                        ดังนั้น
                    </div>
                    <p className="text-[14px] font-semibold">
                        ทางเราจึงขอขยายระยะเวลาดำเนินให้แล้วเสร็จภายในวันที่
                        <span className="text-[#1890FF]">
                            {' '}
                            {moment(detail?.dueDate)
                                .add(29, 'days')
                                .format('DD/MM/YYYY')}
                        </span>
                    </p>
                    <div className="text-[14px] font-semibold">
                        ต้องขออภัยเป็นอย่างสูง
                    </div>
                    <div className="flex justify-center">
                        <IconFlowInProgress />
                    </div>

                    <p className="text-[14px] font-semibold">
                        อัปเดตล่าสุดเมื่อ :{' '}
                        <span className="font-normal">
                            {moment(new Date()).format('DD/MM/YYYY') || '-'}
                        </span>
                    </p>
                    <div className="text-[14px] font-semibold">
                        ข้อมูลเพิ่มเติม{' '}
                    </div>
                    <Form.Item className="mt-2" name={'operatorRemark'}>
                        <TextArea
                            size="large"
                            className="bg-[#F4F6FC]"
                            autoSize={{ minRows: 3, maxRows: 4 }}
                            placeholder={t('MyTask.DescribeDetails')}
                        />
                    </Form.Item>
                    <div className="text-[14px] font-semibold text-[#65707A] mt-8">
                        หากมีข้อสงสัยประการใด
                        สามารถติดต่อคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล
                    </div>
                    <div className="text-[14px] text-[#65707A] whitespace-pre-line">
                        {lang === 'en'
                            ? parse(contact?.staffNameDPOEn || '-')
                            : parse(contact?.staffNameDPOTh || '-')}
                    </div>
                    <div
                        className="my-4"
                        style={{ borderBottom: ' 2px solid #F5F6FF' }}
                    ></div>
                    <div className="p-4 text-center text-[12px] text-[#171717]">
                        Copyright © 2022 Whitefact
                    </div>
                </div>
            </div>
            <BackTop>
                <div className="flex items-center justify-center" style={style}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
        </>
    );
}

const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};
